import React, { useEffect, useState, useRef } from "react";
import BrushIcon from "@mui/icons-material/Brush";
import styles from "../../Styles/CreatorDash/styles.module.css";
import axios from "axios";
import { getCreator, getUser } from "../../helper/authApiCalls/auth";
import VerifiedIcon from "@mui/icons-material/Verified";
import { addProfileImage } from "../../helper/creatorsApiCalls/creator";
import { API } from "../../backend";

const Manage = () => {
  const [user, setUser] = useState({});
  const [image, setImage] = useState({
    profileimage: "",
  });
  const [success, setSuccess] = useState(false);

  const { role } = atob(
    JSON.parse(localStorage.getItem("_access_token")).split(".")[1],
  );

  useEffect(() => {
    const fetchData = async () => {
      if (role === "creator") {
        let response = await getCreator();
        setUser(response.data);
      } else {
        let response = await getUser();
        setUser(response.data);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (field) => {
    var data = JSON.stringify({
      field: field,
      value: `${user[field]}`,
    });

    var config =
      role === "creator"
        ? {
            method: "put",
            url: `${API}/creator/edit`,
            headers: {
              Authorization: `Bearer ${JSON.parse(
                localStorage.getItem("_access_token"),
              )}`,
              "Content-Type": "application/json",
            },
            data: data,
          }
        : {
            method: "put",
            url: `${API}/user/edituser`,
            headers: {
              Authorization: `Bearer ${JSON.parse(
                localStorage.getItem("_access_token"),
              )}`,
              "Content-Type": "application/json",
            },
            data: data,
          };

    axios(config).then(() => {
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    });
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const fileInputRef = useRef();
  const handleProfileImage = (name) => (e) => {
    setImage({ ...image, [name]: e.target.files });
    if (e.target.files && e.target.files.length > 0) {
      onProfileSubmit(e.target.files[0]);
    }
  };
  const handleEditPhotoClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };
  const onProfileSubmit = (file) => {
    const userId = user._id;
    let formData = new FormData();
    formData.append("profileimage", file);
    addProfileImage(formData, userId).then(() => {
      setSuccess(true);
      window.location.reload(false);
    });
  };

  return (
    <div className={styles.manage}>
      <div className={styles.inpu}>
        {success && (
          <div className={styles.sucC}>
            <VerifiedIcon className={styles.verified} />
            <p className={styles.success}>Successfully Updated</p>
          </div>
        )}

        {/* Profile Image Section - now left aligned */}
        <div className={styles.profileImageSection}>
          <div className={styles.profileImageWrapper}>
            {user.profileimage ? (
              <img
                src={user.profileimage}
                alt="Profile"
                className={styles.profileImage}
                onClick={() => setShowImageModal(true)}
                style={{ cursor: "pointer" }}
              />
            ) : (
              <span>No image yet</span>
            )}
            <span
              className={styles.editIcon}
              onClick={handleEditPhotoClick}
              title="Edit profile image"
              style={{ cursor: "pointer", marginLeft: 8 }}
            >
              <BrushIcon fontSize="medium" />
            </span>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleProfileImage("profileimage")}
            />
          </div>
          {/* The rest of the profile settings will be to the right of the image */}
          <div style={{ flex: 1 }}></div>
        </div>

        {/* Modal for full screen image */}
        {showImageModal && user.profileimage && (
          <div
            className={styles.imageModal}
            onClick={() => setShowImageModal(false)}
          >
            <img
              src={user.profileimage}
              alt="Profile Fullscreen"
              className={styles.fullscreenImage}
            />
          </div>
        )}

        {/* Name Section */}
        <div className={styles.naam}>
          <span>Name</span>
        </div>
        <div className={styles.in1}>
          <div className={styles.inp}>
            <input
              type="text"
              name="name"
              value={user.name || ""}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inbut}>
            <button onClick={() => handleSubmit("name")}>Submit</button>
          </div>
        </div>

        <div className={styles.naam}>
          <span>Email</span>
        </div>
        <div className={styles.in1}>
          <div className={styles.inp}>
            <input type="text" value={user.email || ""} readOnly />
          </div>
        </div>

        {role === "creator" && (
          <>
            <div className={styles.naam}>
              <span>Phone</span>
            </div>
            <div className={styles.in1}>
              <input
                type="text"
                name="mobile"
                value={user.mobile || ""}
                onChange={handleChange}
              />
              <button onClick={() => handleSubmit("mobile")}>Submit</button>
            </div>

            <div className={styles.naam}>
              <span>Location</span>
            </div>
            <div className={styles.in1}>
              <input
                type="text"
                name="location"
                value={user.location || ""}
                onChange={handleChange}
              />
              <button onClick={() => handleSubmit("location")}>Submit</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Manage;
